import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "保险公司", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增目标", -1)
const _hoisted_5 = { class: "flex flexC button-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "编辑", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "删除", -1)
const _hoisted_8 = { class: "flex flexR mar-t-22" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        class: "mar-r-16",
        style: {"width":"180px"},
        modelValue: _ctx.screenParams.b_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParams.b_id = $event)),
        placeholder: "请选择",
        clearable: "",
        onChange: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insuranceList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.name,
              value: item.id,
              key: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        class: "bg-red mar-l-16",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialog(null)))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "保险公司",
            align: "center",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.bxgs_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "月份",
            align: "center",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.month), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "目标金额",
            align: "center",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode("¥" + _toDisplayString(_ctx.formatMoney(scope.row.money)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.openDialog(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.delRow(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.editForm.id ? '编辑业务' : '新增业务',
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = $event)),
      center: "",
      width: 500
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.editForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "保险公司",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _ctx.editForm.b_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editForm.b_id = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insuranceList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "月份",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"100%"},
                  modelValue: _ctx.editForm.month,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editForm.month = $event)),
                  type: "month",
                  format: "YYYY-MM",
                  placeholder: "请选择月份"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "目标金额",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"100%"},
                  modelValue: _ctx.editForm.money,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editForm.money = $event)),
                  placeholder: "请输入目标金额"
                }, {
                  append: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}